// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__33TK6","small":"badge_small__1AJoo","medium":"badge_medium__3FvfA","large":"badge_large__ARgSq"};